import { useAuthStore } from "@/store/authStore";
import Forbidden from "@/pages/Forbidden";

interface CompanyAdminRouteProps {
  children: React.ReactNode;
}

const CompanyAdminRoute = ({ children }: CompanyAdminRouteProps) => {
  const user = useAuthStore((state) => state.user);

  if (!user?.is_admin && !user?.is_company_admin) {
    return <Forbidden />;
  }

  return <>{children}</>;
};

export default CompanyAdminRoute;
